import { Reducer } from "redux";

/**
 * REDUX SETTINGS
 * Mapping of the redux reducers and their names.
 */

// Reducers
import authReducer, { actions as authActions, IState as IAuthState } from "./ducks/auth";

export const reduxReducers: { [key: string]: Reducer<{}> } = {
    auth: authReducer,
};

// Action Creators
export const reduxActions = {
    auth: authActions,
};

// Store interface
export interface IReduxStore {
    auth: IAuthState;
    router: {
        location: {
            hash: string;
            pathname: string;
            search: string;
            state: undefined;
        };
    };
    [key: string]: {};
}

// Props interface for connected components
export interface IReduxProps {
    actions: typeof reduxActions;
    store: IReduxStore;
    [key: string]: {};
}



// WEBPACK FOOTER //
// ./src/settings-redux.ts